// Libraries
var React = require('react');
var ReactDOM = require('react-dom');
var $ = require('jquery');

// Components
var HashtagItem = require('./HashtagItem');
var PromptModule = require('../PromptModule/PromptModule');
var Checkbox = require('Checkbox/CheckboxModule');

// Styles
require('./Hashtag.scss');

class Hashtag extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			tags: this.props.data.tags.map((tag, i) => Object.assign({}, tag, {index: i})),
			alphaSorting: false,
			baseUrl: this.props.data.baseUrl,
			showRefreshLink: false,
		};
	}

	byTimeAdded = (a, b) => {
		return a.index - b.index;
	};

	byAlphaNum = (a, b) => {
		return a.hashtag.localeCompare(b.hashtag);
	};

	removeTag = id => {
		$.ajax(this.state.baseUrl + '/unfollow?id=' + id)
			.done(data => {
				this.setState({
					tags: this.state.tags.filter(tag => tag.id !== Number(id)),
					showRefreshLink: true,
				});
			});
	};

	handleRemove = e => {
		const id = e.currentTarget.getAttribute('data-id');

		ReactDOM.render(
			<PromptModule
				callback={this.removeTag.bind(this, id)}
				promptTitle="Confirm"
				promptText="Are you sure you want to remove this tag?"
				caption="Yes"
			/>,
			document.getElementById('SpursPrompt')
		);
	};

	handleSorting = _ => {
		const tags = this.state.tags.sort(!this.state.alphaSorting ? this.byAlphaNum : this.byTimeAdded)
		this.setState({ tags, alphaSorting: !this.state.alphaSorting });
	};

	render() {
		return (
			<div className="Hashtag">
				<div className="Hashtag__sort">
					<div className="container">
						<Checkbox callback={this.handleSorting} labelChecked="Sort A to Z" labelUnchecked="Sort A to Z" id="sortTags" background="dark" position="right" />
					</div>
				</div>
				{this.state.tags ?
					this.state.tags.map(tag => (
						<HashtagItem key={tag.id} handleRemove={this.handleRemove} tag={tag} />
					)) : (
						<p className="Hashtag__clue">You haven't followed any tags yet...</p>
					)
				}
				{this.state.showRefreshLink && document.querySelector('.TrendingGrid') &&
					<div className="Hashtag__refresh">
						<a href={window.location.href}>Now <span>refresh your browser</span> to update your results</a>
					</div>
				}
			</div>
		);
	}
}

module.exports = Hashtag;



// WEBPACK FOOTER //
// ./src/components/HashtagModule/HashtagModule.js